import React from 'react';
import { useIsDesktop } from '@/hooks/useMediaQuery';
import { AllPositionsPageDesktop } from './AllPositionsPage.Desktop';
import { AllPositionsPageMobile } from './AllPositionsPage.Mobile';

/**
 * AllPositionsPage - Switches between desktop and mobile layouts based on screen size.
 */
export const AllPositionsPage: React.FC = () => {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return <AllPositionsPageDesktop />;
  }

  return <AllPositionsPageMobile />;
};
